import { useState, useCallback } from 'react'
import { authFetch } from '../utils/authFetch'

interface InvoiceDetail {
  id: number
  amount: number
  createdAt: string
  daysInMonth: number
  proportionalAmount: number
}

export interface RoiData {
  influencedRevenue: number
  totalCost: number
  proportionalCost: number
  roi: number | null
  invoicesFound: number
  invoiceDetails: InvoiceDetail[]
  rangeDays: number
}

export function useRoi() {
  const [roiData, setRoiData] = useState<RoiData | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const fetchRoi = useCallback(async (
    companyKey: string,
    startDate: string,
    endDate: string,
    influencedRevenue: number
  ) => {
    setIsLoading(true)
    try {
      const params = new URLSearchParams({
        startDate,
        endDate,
        influencedRevenue: String(influencedRevenue),
      })
      const response = await authFetch(`/api/roi/${encodeURIComponent(companyKey)}?${params}`)

      if (!response.ok) {
        throw new Error('Failed to fetch ROI')
      }

      const data: RoiData = await response.json()
      setRoiData(data)
    } catch (err) {
      console.error('Error fetching ROI:', err)
      setRoiData(null)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const clearRoi = useCallback(() => setRoiData(null), [])

  return { roiData, isLoading, fetchRoi, clearRoi }
}
